export default __webpack_public_path__ + "static/media/Green0004.63e1b4f8.png";